import React, { useState } from 'react';
import SvgIcon from '../../components/SvgIcon';

const ProfileAccuracyWarningModal = ({ isOpen, onClose, onConfirm, isSubmitting }) => {
  const [declared, setDeclared] = useState(false);

  if (!isOpen) return null;

  return (
    <div 
      className="admin-modal-overlay" 
      style={{
        zIndex: 20050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        backgroundColor: 'rgba(15, 23, 42, 0.75)',
        backdropFilter: 'blur(4px)',
        position: 'fixed',
        inset: 0
      }}
      data-testid="profile-accuracy-warning-modal"
    >
      <div 
        style={{
          width: '100%',
          maxWidth: '540px',
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          overflow: 'hidden',
          animation: 'fadeIn 0.25s ease-out'
        }}
      >
        {/* Modal Header */}
        <div 
          style={{
            padding: '1.5rem 1.75rem',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex',
            alignItems: 'center',
            gap: '0.85rem'
          }}
        >
          <div 
            style={{
              width: '42px',
              height: '42px',
              borderRadius: '10px',
              backgroundColor: '#fef3c7',
              color: '#d97706',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            <SvgIcon name="shield" size={24} />
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 800, color: '#0f172a' }}>
              Confirm Profile Accuracy
            </h3>
            <p style={{ margin: '2px 0 0 0', fontSize: '0.825rem', color: '#64748b' }}>
              Cybersecurity Training Prerequisite Declaration
            </p>
          </div>
          <button 
            type="button" 
            onClick={onClose} 
            style={{
              background: 'transparent',
              border: 'none',
              color: '#94a3b8',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '6px'
            }}
            aria-label="Close modal"
          >
            <SvgIcon name="close" size={20} />
          </button>
        </div>

        {/* Modal Body */}
        <div style={{ padding: '1.75rem' }}>
          {/* Important Notice Box */}
          <div 
            style={{
              backgroundColor: '#fffbeb',
              border: '1px solid #fde68a',
              borderLeft: '4px solid #f59e0b',
              borderRadius: '8px',
              padding: '1rem 1.25rem',
              marginBottom: '1.5rem',
              fontSize: '0.875rem',
              color: '#92400e',
              lineHeight: 1.6
            }}
          >
            <strong>Important Prerequisite Notice:</strong>
            <p style={{ margin: '6px 0 0 0' }}>
              Please ensure your IT Background and Cybersecurity Experience details are accurate. These records determine your qualification and eligibility to enroll in intermediate and advanced certification courses. Once submitted, changes may require administrative approval.
            </p>
          </div>

          {/* Declaration Checkbox */}
          <label 
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '0.85rem',
              padding: '1rem',
              backgroundColor: declared ? '#eff6ff' : '#f8fafc',
              border: `1.5px solid ${declared ? '#3b82f6' : '#cbd5e1'}`,
              borderRadius: '10px',
              cursor: 'pointer',
              transition: 'all 0.15s ease'
            }}
          >
            <input
              type="checkbox"
              id="profile-accuracy-declaration-checkbox"
              data-testid="declaration-checkbox"
              checked={declared}
              onChange={(e) => setDeclared(e.target.checked)}
              style={{
                width: '18px',
                height: '18px',
                marginTop: '2px',
                cursor: 'pointer',
                accentColor: '#4f46e5'
              }}
            />
            <span style={{ fontSize: '0.875rem', color: '#1e293b', fontWeight: 600, lineHeight: 1.5 }}>
              I declare that my technical background and experience information is truthful and correct.
            </span>
          </label>
        </div>

        {/* Modal Footer Actions */}
        <div 
          style={{
            padding: '1.25rem 1.75rem',
            backgroundColor: '#f8fafc',
            borderTop: '1px solid #e2e8f0',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.85rem'
          }}
        >
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            style={{
              padding: '0.65rem 1.25rem',
              backgroundColor: '#ffffff',
              border: '1px solid #cbd5e1',
              borderRadius: '8px',
              fontSize: '0.875rem',
              fontWeight: 600,
              color: '#475569',
              cursor: isSubmitting ? 'not-allowed' : 'pointer'
            }}
            data-testid="review-details-btn"
          >
            Review Details
          </button>

          <button
            type="button"
            disabled={!declared || isSubmitting}
            onClick={() => onConfirm()}
            style={{
              padding: '0.65rem 1.5rem',
              backgroundColor: !declared || isSubmitting ? '#94a3b8' : '#4f46e5',
              border: 'none',
              borderRadius: '8px',
              fontSize: '0.875rem',
              fontWeight: 700,
              color: '#ffffff',
              cursor: !declared || isSubmitting ? 'not-allowed' : 'pointer',
              boxShadow: !declared || isSubmitting ? 'none' : '0 4px 12px rgba(79, 70, 229, 0.35)',
              transition: 'all 0.15s ease'
            }}
            data-testid="confirm-save-profile-btn"
          >
            {isSubmitting ? 'Saving Profile...' : 'Confirm & Save'}
          </button>
        </div>

      </div>
    </div>
  );
};

export default ProfileAccuracyWarningModal;
